const gestureSets = [
    { id: 'set1', label: 'Set 1', gestures: ['sick', 'hilarious', 'disappointed', 'funny_or_stop_that', 'LOL'] },
    { id: 'set2', label: 'Set 2', gestures: ['finish', 'hands_off', 'mind_boggling', 'thats_all'] },
    { id: 'set3', label: 'Set 3', gestures: ['awful', 'impossible', 'believe-it-or-not'] },
    { id: 'set4', label: 'Set 4', gestures: ['wrong', 'accidentally', 'unexpectedly', 'what_matters'] },
    { id: 'set5', label: 'Set 5', gestures: ['good', 'see_you_later', 'best'] }
];

// Special cases for gesture display names
const specialDisplayNames = {
    'what_matters': 'what matters?',
    'thats_all': 'that\'s all'
};

// Helper function to format gesture names for display in the UI
export const formatGestureForDisplay = (gesture) => {
    // Check for special cases first
    if (specialDisplayNames[gesture]) {
        return specialDisplayNames[gesture];
    }

    let formatted = gesture;

    // Replace "_or_" with "/"
    formatted = formatted.replace(/_or_/g, '/');

    // Replace remaining underscores with spaces
    formatted = formatted.replace(/_/g, ' ');

    // Handle version suffix pattern (e.g., "-v2", "-v3")
    if (/-v\d+$/.test(formatted)) {
        const [prefix, version] = formatted.split('-v');
        return `${prefix} [v${version}]`;
    }

    return formatted;
};

const gestureInstructions = {
    'sick': ['Eye Aperture: Squinted', 'Eyebrows: Lowered', 'Nose: Slightly Tensed', 'Mouth: Grimace with Teeth'],
    'hilarious': ['Smile widely', 'Shake hands'],
    'disappointed': ['Frown slightly', 'Shake head'],
    'funny_or_stop_that': ['Gesture "funny"', 'Move hands to signal stop'],
    'LOL': ['Make L-hand shapes', 'Rotate wrists'],
    'finish': ['Flatten hands', 'Move forward'],
    'hands_off': ['Hold palms out', 'Push away'],
    'mind_boggling': ['Open hands near head', 'Shake quickly'],
    'thats_all': ['Hold one hand up', 'Slide across other palm'],
    'awful': ['Scrunch face', 'Throw hands outward'],
    'impossible': ['Shake fists', 'Move downward'],
    'believe-it-or-not': ['Point to temple', 'Flip hand open'],
    'wrong': ['Make Y-hand at chin', 'Twist wrist'],
    'accidentally': ['Brush pinky along thumb', 'Drop hand'],
    'unexpectedly': ['Raise eyebrows', 'Move hands apart'],
    'what_matters': ['Point to chest', 'Sweep outward'],
    'good': ['Place hand at chin', 'Move forward'],
    'see_you_later': ['Point to eye', 'Make L-hand outward'],
    'best': ['Give thumbs up', 'Move hand upward'],
    'hello': ['Raise hand near temple', 'Move outward'],
    'thanks': ['Touch chin then move forward'],
    'yes': ['Make a fist', 'Nod up and down'],
    'no': ['Pinch index and middle to thumb']
};

export { gestureSets, gestureInstructions };
